<script>
export default {
  data () {
    return {
      check1: false,
      check2: false,
      check3: false
    }
  },
  watch: {
    check1: function () {
      if (this.check1) {
        this.check2 = false
        this.check3 = false
      }
    },
    check2: function () {
      if (this.check2) {
        this.check1 = false
        this.check3 = false
      }
    },
    check3: function () {
      if (this.check3) {
        this.check1 = false
        this.check2 = false
      }
    }
  },
  methods: {
    print () {
      // 出EXCEL
      if (this.check1) {
        this.$emit('goPrintExcel')
      }
      // 出CSV
      if (this.check2) {
        this.$emit('goPrint')
      }
      // 。。。
      if (this.check3) {
        this.$emit('goPrintShiftStatisticExcel')
      }
      this.check1 = false
      this.check2 = false
      this.check3 = false
    }
  }
}
</script>

<template>
  <div class="col-md-12 column">
        <div class="modal fade" id="modal-container-print-selector" data-backdrop="static" style="backdrop: 'static'" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <!-- header -->
                    <div class="modal-header">
                      <button type="button" class="close" data-dismiss="modal" aria-hidden="true"><img height="20px" src="@/assets/button/close_button.png" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;"/></button>
                    </div>
                    <!-- body -->
                    <div class="modal-body">
                        <div class="select-item">
                            <input type="checkbox" v-model="check1" class="checkbox" > <span class="span">利用集計表出力</span>
                        </div>
                        <div class="select-item">
                            <input type="checkbox" v-model="check2" class="checkbox"> <span class="span">一覧出力</span>
                        </div>
                        <div class="select-item">
                            <input type="checkbox" v-model="check3" class="checkbox"> <span class="span">運行内訳表出力</span>
                        </div>
                    </div>
                    <!-- footer -->
                    <div class="footer">
                        <button class="print-button bgc4" @click="print" data-dismiss="modal">出力</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .modal-dialog{
        height: 100%;
        display: flex;
        align-items: center;
    }
    .modal-content{
        width: 400px;
        height: 250px;
        display: flex;
        flex-direction: column;
    }
    .modal-header{
        border-bottom: 0px;
    }
    .modal-body{
        display: flex;
        flex-direction: column;
        flex: 3;
    }
    .select-item{
        display: flex;
        flex:1;
        margin-left: 50px;
        margin-right: 50px;
        align-items: center;
    }
    .checkbox{
        width: 18px;
        height: 18px;
    }
    .span{
        display: flex;
        justify-content: flex-end;
        width: 100%;
        font-size: 18px;
    }
    .footer{
        flex: 1;
    }
    .print-button{
        width: 120px;
        color: white;
        border: 0px;
        border-radius: 5px;
        font-size: 18px;
    }
</style>



// WEBPACK FOOTER //
// src/components/PrintSelectDialog.vue